module.exports = __webpack_public_path__ + "static/media/emotion_sad.08a4b1d8.svg";